import { render } from "./NetToGross.vue?vue&type=template&id=12c50cfe&scoped=true&ts=true"
import script from "./NetToGross.vue?vue&type=script&lang=ts"
export * from "./NetToGross.vue?vue&type=script&lang=ts"

import "./NetToGross.vue?vue&type=style&index=0&id=12c50cfe&scoped=true&lang=css"
import "./NetToGross.vue?vue&type=style&index=1&id=12c50cfe&lang=css"

import exportComponent from "C:\\Users\\Dell\\Desktop\\Projekte\\paga-ime\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c50cfe"]])

export default __exports__